// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 2143 ? "app" : chunkId) + "-" + {"2143":"e56d02e24b849b28a529","4023":"1cb5432c3661cea3ce4b"}[chunkId] + ".css";
};